import React, { useState } from 'react';
import SerialNumbers from '../components/business/SerialNumbers';

export const SerialNumbersCtx = React.createContext({});

function SerialNumbersPageProvider(props) {
  const [ search, setSearch ] = useState('');
  const [ dataCSV, setDataCSV ] = useState(null);

  const ctx = {
    search,
    setSearch,
    dataCSV,
    setDataCSV,
  };
  return (
    <SerialNumbersCtx.Provider value={ ctx }>
      {props.children}
    </SerialNumbersCtx.Provider>
  );
}

function SerialNumbersPage() {
  return (
    <SerialNumbersPageProvider>
      <SerialNumbers />
    </SerialNumbersPageProvider>
  );
}

export default SerialNumbersPage;
